import { clearAuth } from '../utils/storage';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box, Typography, Grid, Button, Chip, Divider, Stack, Tabs, Tab, Paper, Fade, CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip,
  IconButton,
  Link,
  Rating,
  Menu,
  MenuItem
} from '@mui/material';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useState, useEffect } from 'react';
import axios from 'axios';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SpeedIcon from '@mui/icons-material/Speed';
import GroupIcon from '@mui/icons-material/Group';
import ViewListIcon from '@mui/icons-material/ViewList';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import CloseIcon from '@mui/icons-material/Close';
import PhoneIcon from '@mui/icons-material/Phone';
import VehicleMedia from '../components/VehicleMedia';
import CarImageGallery from '../components/CarImageGallery';
import { WidthFull } from '@mui/icons-material';
import CarLoanPopup from '../components/CarLoanPopup';
import DealerCard from '../components/DealerCard';
import DealerCard2 from '../components/DealerCard2';

import axiosInstance from '../services/axiosInstance';
import { endpoints } from '../services/endpoints';

import NotFoundPage from './NotFoundPage';
import depreciationIcon from '../assets/icons/depreciation.svg';
import coe from '../assets/icons/coe-left.svg'
import dayjs from 'dayjs'; // ensure you import this at the top
import { enqueueSnackbar } from 'notistack';

interface HomePageProps {
  mode: 'light' | 'dark';
  setMode: (mode: 'light' | 'dark') => void;
}

const CarDetailPage = ({ mode, setMode }: HomePageProps) => {
  const [isLoggedIn, setLoggedin] = useState<boolean>(false);

  const { id } = useParams<{ id: string }>();
  const [vehicle, setVehicle] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedImage, setSelectedImage] = useState<string>('');
  const [tabIndex, setTabIndex] = useState(0);
  const [tabIndex2, setTabIndex2] = useState(0);
  const [salesPersons, setSalesPersons] = useState<any[]>([]);
  const [groupedMode, setGroupedMode] = useState(false);
  const [open, setOpen] = useState(false);
  const [calcOpen, setcalcOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [galleryExpanded, setGalleryExpanded] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const [selectedPhone, setSelectedPhone] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [adSpaceList, setAdSpaceList] = useState<any[]>([]);
  // inside your component
  const [dealerFirstIndex, setDealerFirstIndex] = useState(0);
  const [dealerSecondIndex, setDealerSecondIndex] = useState(0);






  const fetchVehicle = async () => {
    if (!id) {
      setError('Invalid vehicle ID.');
      setLoading(false);
      return;
    }
    try {
      setLoading(true);

      interface VehicleResponse {
        responseData: any;
        [key: string]: any;
      }
      const res = await axiosInstance.get<VehicleResponse>(endpoints.vehicle.getSinglePublished(id));
      const responseData = res.data?.responseData;

      const persons: any[] = [
        responseData.salesPerson1,
        responseData.salesPerson2,
        responseData.salesPerson3,
        responseData.salesPerson4,
      ].filter(Boolean); // Removes null or undefined

      setSalesPersons(persons);
      setVehicle(responseData);
      setSelectedImage(responseData.vehicleImage?.[0]?.vehicleImageUrl || '');
    } catch (err) {
      setError('Failed to fetch vehicle data.');
    } finally {
      setLoading(false);
    }
  };

  const fetchAdData = async () => {
    try {
      const response = await axiosInstance.post(
        "/CustomerVehicle/VehicleMultipleDataList",
        { adSpaceData: true },
        { headers: { "Content-Type": "application/json" } }
      );

      const result = response.data as {
        responseCode: string;
        responseMessage?: string;
        responseData?: { adSpaceData?: any[] };
      };

      if (result.responseCode === "00" && result.responseData) {
        setAdSpaceList(result.responseData.adSpaceData || []);
      } else {
        enqueueSnackbar(result.responseMessage || "⚠️ Failed to load ad data", {
          variant: "error",
        });
      }
    } catch {
      enqueueSnackbar("❌ Error fetching ad data", { variant: "error" });
    }
  };


  // Split dealer ads into two lists by position
  const dealerFirstList = adSpaceList.filter(
    ad =>
      ad.adPositionCode === 'dealer-first' &&
      ad.dealerId === vehicle?.vehicleDealerInfo?.dealerId
  );

  const dealerSecondList = adSpaceList.filter(
    ad =>
      ad.adPositionCode === 'dealer-second' &&
      ad.dealerId === vehicle?.vehicleDealerInfo?.dealerId
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (dealerFirstList.length > 0) {
        setDealerFirstIndex((prev) => (prev + 1) % dealerFirstList.length);
      }
      if (dealerSecondList.length > 0) {
        setDealerSecondIndex((prev) => (prev + 1) % dealerSecondList.length);
      }
    }, 3000); // 3 seconds

    return () => clearInterval(interval);
  }, [dealerFirstList, dealerSecondList]);

  useEffect(() => {

    fetchVehicle();
    fetchAdData();
  }, [id]);

  if (error) return <NotFoundPage />;
  // if (!vehicle) return <Typography variant="h6">Vehicle not found.</Typography>;


  const labelTextStyle = {
    fontSize: 13,
    color: 'text.secondary',
    mb: 0.5,
  };

  const valueTextStyle = {
    fontSize: 14,
    color: 'text.primary',
  };


  const InfoBlock = ({
    label,
    value,
    dangerouslySet = false,
  }: {
    label: string;
    value: React.ReactNode;
    dangerouslySet?: boolean;
  }) => (
    <Box sx={{ mb: 2 }}>
      <Typography sx={{ ...labelTextStyle, fontWeight: 'bold' }}>
        {label}
      </Typography>

      {dangerouslySet ? (
        <Typography
          sx={{ ...valueTextStyle, fontWeight: 'normal', color: 'grey.700' }}
          component="div"
          dangerouslySetInnerHTML={{ __html: String(value) }}
        />
      ) : (
        <Typography sx={{ ...valueTextStyle, fontWeight: 'normal', color: 'grey.600' }}>
          {value}
        </Typography>
      )}
    </Box>
  );

  const SectionWrapper = ({
    title,
    description,
    children,
  }: {
    title: string;
    description?: React.ReactNode;
    children: React.ReactNode;
  }) => (
    <Box sx={{ px: { xs: 0, md: 1 }, py: 3 }}>
      {/* <Paper
        elevation={2}
        sx={{
          p: { xs: 2, sm: 3 },
          borderRadius: 3,
          border: '1px solid #e0e0e0',
          backgroundColor: '#fff',
        }}
      > */}
      <Typography variant="h6" fontWeight={600} gutterBottom>
        {title}
      </Typography>

      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3 }}
        >
          {description}
        </Typography>
      )}

      <Divider sx={{ mb: 2 }} />

      {children}
      {/* </Paper> */}
    </Box>
  );







  // ========== Overview ==========
  const renderOverview = () => {
    const register = vehicle?.vehicleRegisterInfo;
    const sales = vehicle?.vehicleSalesInfo;
    const groupedOverviewData = [
      {
        title: 'Basic Info',
        data: [
          { label: 'Brand', value: vehicle?.vehicleBrand || '—' },
          { label: 'Model', value: vehicle?.vehicleModelName || '—' },
          { label: 'Make', value: register?.vehicleMake || '—' },
          { label: 'Body Type', value: vehicle?.vehicleBodyType || '—' },
          { label: 'Colour', value: register?.primaryColour || '—' },
          { label: 'Manufacturing Year', value: register?.manufacturingYear ?? 0 },
          { label: 'Mileage', value: `${(sales?.mileage ?? 0).toLocaleString()} km` },
          { label: 'Asking Price', value: `$ ${(sales?.askingPrice ?? 0).toLocaleString()}` },
        ],
      },
      {
        title: 'Specifications',
        data: [
          { label: 'Transmission', value: vehicle?.vehicleTransmissionType || '—' },
          { label: 'Fuel Type', value: vehicle?.vehicleFuelType || '—' },
          { label: 'Seat Capacity', value: vehicle?.seatCapacity ?? 0 },
        ],
      },
      {
        title: 'Registration Details',
        data: [
          { label: 'Original Reg. Date', value: register?.originalRegistrationDate || '—' },
          { label: 'First Reg. Date', value: register?.firstRegistrationDate || '—' },
          { label: 'No. of Owners', value: register?.noOfOwner ?? 0 },
        ],
      },
      {
        title: 'COE Details',
        data: [
          { label: 'COE Category', value: register?.coecategory || '—' },
          { label: 'COE Period', value: `${register?.coeperiod ?? 0} Years` },
          { label: 'COE Expiry', value: register?.coeexpiryDate || '—' },
          { label: 'PQP Paid', value: `$ ${(register?.pqppaid ?? 0).toLocaleString()}` },
          { label: 'COE Rebate', value: `$ ${(register?.coerebateAmount ?? 0).toLocaleString()}` },
          { label: 'OMV', value: `$ ${(register?.openMarketValue ?? 0).toLocaleString()}` },
        ],
      },
    ];

    const flatOverviewData = [
      { label: 'Brand', value: vehicle?.vehicleBrand || '—' },
      { label: 'Model', value: vehicle?.vehicleModelName || '—' },
      { label: 'Make', value: register?.vehicleMake || '—' },
      { label: 'Body Type', value: vehicle?.vehicleBodyType || '—' },
      { label: 'Manufacturing Year', value: register?.manufacturingYear ?? 0 },
      { label: 'Transmission', value: vehicle?.vehicleTransmissionType || '—' },
      { label: 'Fuel Type', value: vehicle?.vehicleFuelType || '—' },
      { label: 'Seat Capacity', value: vehicle?.seatCapacity ?? 0 },
      { label: 'Original Reg. Date', value: `${dayjs(register?.originalRegistrationDate).format('DD/MM/YYYY')}` || '—' },
      { label: 'First Reg. Date', value: `${dayjs(register?.firstRegistrationDate).format('DD/MM/YYYY')}` || '—' },
      { label: 'No. of Owners', value: register?.noOfOwner ?? 0 },
      { label: 'Mileage', value: `${(sales?.mileage ?? 0).toLocaleString()} km` },
      { label: 'Asking Price', value: `$ ${(sales?.askingPrice ?? 0).toLocaleString()}` },
      { label: 'OMV', value: `$ ${(register?.openMarketValue ?? 0).toLocaleString()}` },
      { label: 'COE Category', value: register?.coecategory || '—' },
      { label: 'COE Period', value: `${register?.coeperiod ?? 0} years` },
      { label: 'COE Expiry', value: register?.coeexpiryDate || '—' },
      { label: 'PQP Paid', value: `$ ${(register?.pqppaid ?? 0).toLocaleString()}` },
      { label: 'COE Rebate', value: `$ ${(register?.coerebateAmount ?? 0).toLocaleString()}` },
    ];


    return (
      <>
        <SectionWrapper
          title="Overview"
          description={
            <>
              This <strong>Work Horse Certified</strong> vehicle is carefully inspected and refurbished to ensure top quality.
            </>
          }
        >
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Tooltip title={`Switch to ${groupedMode ? 'Flat View' : 'Grouped View'}`}>
              <IconButton
                size="small"
                onClick={() => setGroupedMode(!groupedMode)}
                color="primary"
              >
                {groupedMode ? <ViewListIcon /> : <ViewModuleIcon />}
              </IconButton>
            </Tooltip>
          </Box>
          {groupedMode ? (
            groupedOverviewData.map((section, idx) => {
              const filteredData = section.data.filter(item => item.value !== null && item.value !== undefined);

              if (filteredData.length === 0) return null; // Skip sections with no valid data

              return (
                <Box key={idx}>
                  <Typography fontWeight={600} gutterBottom sx={{ color: 'primary.main' }}>
                    {section.title}
                  </Typography>

                  <Grid container spacing={1}>
                    {filteredData.map((item, i) => (
                      <Grid key={i} size={{ xs: 5, md: 3 }}>
                        <InfoBlock label={item.label} value={item.value} />
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              );
            })
          ) : (
            <Grid container spacing={1}>
              {flatOverviewData
                .filter(item => item.value !== null && item.value !== undefined)
                .map((item, idx) => (
                  <Grid key={idx} size={{ xs: 5, md: 3 }}>
                    <InfoBlock label={item.label} value={item.value} />
                  </Grid>
                ))}
            </Grid>
          )}
          <Divider sx={{ my: 2 }} />
          {renderSalesInfo()}
        </SectionWrapper>
      </>
    );

  };

  // ========== Sales Info ==========

  const renderSalesInfo = () => {
    const sales = vehicle?.vehicleSalesInfo;

    if (!sales) return null;

    const renderSection = (title: string, content: string) => (
      <Paper
        variant="outlined"
        sx={{ p: 2.5, borderRadius: 2, bgcolor: '#fafafa' }}
      >
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          {title}
        </Typography>
        <InfoBlock value={content} dangerouslySet label="" />
      </Paper>
    );

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {sales.description && renderSection('About this Car', sales.description)}
        {sales.accessories && renderSection('Included Accessories', sales.accessories)}
        {sales.vehicleFeatures && renderSection('Key Specifications', sales.vehicleFeatures)}
      </Box>
    );
  };

  const StyledInfoBlock = ({ label, value }: { label: string; value: string }) => (
    <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        {label}
      </Typography>
      <Typography variant="body1">{value || '-'}</Typography>
    </Paper>
  );

  const renderDealerDetails = () => {
    const dealer = vehicle?.vehicleDealerInfo;
    if (!dealer) return null;

    const googleMapSrc = `https://www.google.com/maps?q=${encodeURIComponent(
      dealer.address
    )}&output=embed`;

    return (
      <SectionWrapper title="Dealer Information">
        <Grid container spacing={2}>
          {[
            { label: 'Dealer Name', value: dealer.dealerName },
            { label: 'Dealer Email', value: dealer.dealerEmail },
            { label: 'UEN', value: dealer.uen },
            { label: 'Contact Number', value: dealer.contactNumber },
            { label: 'Address', value: dealer.address },
          ].map((item, idx) => (
            <Grid size={{ xs: 12, md: item.label === 'Address' ? 12 : 6 }} key={idx}>
              <StyledInfoBlock label={item.label} value={item.value} />
            </Grid>
          ))}

          {/* Embedded Google Map */}
          <Grid size={{ xs: 12 }}>
            <Box sx={{ borderRadius: 2, overflow: 'hidden', mt: 2 }}>
              <iframe
                title="Dealer Location Map"
                width="100%"
                height="300"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src={googleMapSrc}
              />
            </Box>
          </Grid>
        </Grid>
      </SectionWrapper>
    );
  };


  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return renderOverview();
      case 1:
        return vehicle.vehicleDealerInfo.dealerTypeId !== 2
          ? renderDealerDetails()
          : <VehicleMedia vehicle={vehicle} />;
      case 2:
        return vehicle.vehicleDealerInfo.dealerTypeId !== 2
          ? <VehicleMedia vehicle={vehicle} />
          : null; // no case 2 if dealerTypeId === 2
      default:
        return null;
    }
  };



  const coeLeft =
    (vehicle?.vehicleRegisterInfo?.coeRemainingYears ?? 0) * 12 +
    (vehicle?.vehicleRegisterInfo?.coeRemainingMonths ?? 0);




  return (
    <>
      <Header isLoggedIn={isLoggedIn} mode={mode} setMode={setMode} />
      <Box p={1} display="flex" justifyContent="center">
        {loading ? (
          <Paper
            elevation={2}
            sx={{
              p: 2,
              maxWidth: 1300,
              width: '100%',
              borderRadius: 2,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: 300,
            }}
          >
            <CircularProgress />
          </Paper>
        ) : (
          <Box sx={{ maxWidth: 1200, width: '100%' }}>
            <>
              <Grid container spacing={6}>
                {/* LEFT: Image Gallery */}
                <CarImageGallery
                  vehicle={vehicle}
                  setTabIndex={setTabIndex}
                  setGalleryExpanded={setGalleryExpanded}
                />

                {/* RIGHT: Info & Dealer */}
                <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Typography
                    variant="h6"
                    fontWeight={700}
                    sx={{
                      display: '-webkit-box',
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}
                  >
                    {vehicle?.vehicleBrand} {vehicle?.vehicleModelName}
                  </Typography>

                  <Typography
                    variant="h6"
                    color="primary"
                    fontWeight={800}
                    mt={1}
                  >
                    $ {vehicle?.vehicleSalesInfo.askingPrice?.toLocaleString()}
                  </Typography>

                  {/* Sales Info */}
                  <Grid container spacing={0} mt={2}>
                    {[
                      {
                        icon: (
                          <Tooltip title="Annual depreciation value of the car">
                            <img
                              src={depreciationIcon}
                              alt="Depreciation"
                              style={{ width: 20, height: 20 }}
                            />

                          </Tooltip>
                        ),
                        value: `$ ${vehicle?.depreciationValue?.toLocaleString() ?? 0} / year`,
                      },
                      {
                        icon: (
                          <Tooltip title="Time remaining on the COE (Certificate of Entitlement)">
                            <img
                              src={coe}
                              alt="COE Left"
                              style={{ width: 20, height: 20 }}
                            />
                          </Tooltip>
                        ),
                        value: `${vehicle?.vehicleRegisterInfo.coeRemaining?.toLocaleString() ?? 0} COE Left`,
                      },
                      {
                        icon: (
                          <Tooltip title="Total distance the car has been driven">
                            <SpeedIcon fontSize="small" />
                          </Tooltip>
                        ),
                        value:
                          vehicle?.vehicleSalesInfo.mileage !== 0
                            ? `${vehicle.vehicleSalesInfo.mileage.toLocaleString()} km`
                            : 'N/A',
                      },
                      {
                        icon: (
                          <Tooltip title="Number of previous owners of the vehicle">
                            <GroupIcon fontSize="small" />
                          </Tooltip>
                        ),
                        value: `${vehicle?.vehicleRegisterInfo.noOfOwner ?? 0} Owner${vehicle?.vehicleRegisterInfo.noOfOwner > 1 ? 's' : ''
                          }`,
                      },
                    ].map((item, idx) => (
                      <Grid size={{ xs: 6 }} key={idx}>
                        <Box display="flex" gap={1} py={0.75} sx={{ width: '100%' }}>
                          {item.icon}
                          <Typography variant="body2" fontWeight={600} lineHeight={1.5}>
                            {item.value}
                          </Typography>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                  {/* Finance Button */}
                  <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<AttachMoneyIcon />}
                    sx={{
                      mt: 2,
                      backgroundColor: '#ffe003',
                      color: 'black',
                      borderColor: '#ffce00',
                      fontWeight: 600,
                      '&:hover': {
                        backgroundColor: '#e5e5e5ff',
                      },
                    }}
                    onClick={() => setcalcOpen(true)}
                  >
                    Calculate Financing
                  </Button>

                  <CarLoanPopup
                    open={calcOpen}
                    onClose={() => setcalcOpen(false)}
                    price={vehicle?.vehicleSalesInfo?.askingPrice}
                    coeLeft={coeLeft}
                    totalCoe={vehicle?.vehicleRegisterInfo?.coerebateAmount}
                    depreciation={vehicle?.depreciationValue}
                  />

                  <Box>
                    <DealerCard2 vehicle={vehicle} />
                  </Box>



                </Grid>
              </Grid>



              <Divider sx={{ my: 3 }} />
              <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2}>
                {/* LEFT: Tabbable Content */}
                <Box sx={{ flex: 1, maxWidth: 800 }}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                    <Tabs
                      value={activeTab}
                      onChange={handleTabChange}
                      variant="scrollable"
                      scrollButtons="auto"
                      textColor="primary"
                      indicatorColor="primary"
                    >
                      <Tab label="Overview" />
                      {vehicle.vehicleDealerInfo.dealerTypeId !== 2 ? (
                        <Tab label="Dealer Details" />
                      ) : null}
                      <Tab label="Media" />
                    </Tabs>
                  </Box>

                  {/* Dynamic Content */}
                  {renderTabContent()}
                </Box>

                {/* RIGHT: Info Sidebar */}
                <Box sx={{ width: 320 }}>
                  {/* Dealer First Rotating Ad */}
                  {dealerFirstList.length > 0 && (
                    <Box
                      mt={{ xs: 2, md: 0 }}
                      sx={{
                        overflow: 'hidden',
                        width: 320,
                        height: 150,
                      }}
                    >
                      <a
                        href={dealerFirstList[dealerFirstIndex].adSpaceThumbnailUrl || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: 'block', width: '100%', height: '100%' }}
                      >
                        <img
                          src={dealerFirstList[dealerFirstIndex].adSpaceImageUrl}
                          alt={dealerFirstList[dealerFirstIndex].name || `Dealer First Ad`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            display: 'block',
                          }}
                        />
                      </a>
                    </Box>
                  )}

                  {/* Dealer Second Rotating Ad */}
                  {dealerSecondList.length > 0 && (
                    <Box
                      mt={2}
                      sx={{
                        overflow: 'hidden',
                        width: 320,
                        height: 150,
                      }}
                    >
                      <a
                        href={dealerSecondList[dealerSecondIndex].adSpaceThumbnailUrl || '#'}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ display: 'block', width: '100%', height: '100%' }}
                      >
                        <img
                          src={dealerSecondList[dealerSecondIndex].adSpaceImageUrl}
                          alt={dealerSecondList[dealerSecondIndex].name || `Dealer Second Ad`}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'contain',
                            display: 'block',
                          }}
                        />
                      </a>
                    </Box>
                  )}
                </Box>



              </Box>

            </>

          </Box>
        )}

      </Box>
      <Footer />
    </>
  );
};

export default CarDetailPage;
